import {
  collection,
  doc,
 getDoc,
  getDocs,
  query,
  orderBy,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

const COL_NAME = "sections";

export async function listSections() {
  const q = query(collection(db, COL_NAME), orderBy("order", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));
}

export async function createSection({ slug, label, order = 999, visible = true }) {
  const ref = doc(db, COL_NAME, slug);
  const exists = await getDoc(ref);

  if (exists.exists()) {
    throw new Error("Esiste già una sezione con questo slug.");
  }

  await setDoc(ref, {
    slug,
    label,
    order,
    visible,
    createdAt: serverTimestamp(),
  });
}

export async function deleteSection(slug) {
  await deleteDoc(doc(db, COL_NAME, slug));
}